import React from "react";
import { Link } from "react-router-dom";
import config from "../../../util/config";

const ReferralSupport = () => {
  return (
    <div>
      <div className="flex flex-col px-5  py-5 bg-[#FFF9E5] max-md:w-full w-full mx-auto lg:px-24 min-max-md:px-14 md:my-10">
        <div className="flex flex-col justify-start items-start relative max-md:gap-2">
          <div className="relative flex items-start justify-start">
            <h2 className="font-medium text-3xl md:text-4xl tracking-tight max-md:gap-2 whitespace-break-spaces">
              College Mentor{" "}
              <span className="text-[#d33a3a]">Referral Support</span>
            </h2>
          </div>
          <p className="text-sm md:text-lg text-gray-500 font-medium max-md:mt-2 tracking-wide">
            Talk to our experts. We’re available @ office timings (10A.M - 6
            P.M)
          </p>
        </div>

        <div className="flex flex-col md:gap-4 max-md:gap-3 justify-center items-start">
          <div className="flex md:pt-12 pt-9 max-md:flex-col md:flex-row w-full max-md:gap-2 md:gap-0 max-sm:pt-2">
            <div className="flex md:gap-5 max-md:gap-4 md:flex-row max-md:flex-col  md:border-r  pb-4 md:pb-0 md:pr-9">
              <div className="flex gap-3 items-center">
                <p className="md:text-lg font-medium text-sm tracking-wide">
                  Reach out to us at
                </p>
              </div>
              <button className="flex items-center gap-2.5 rounded-lg border border-[#d33a3a] py-3 px-6 md:min-w-[236px] justify-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="14"
                  viewBox="0 0 15 14"
                  fill="none"
                >
                  <path
                    d="M0.713867 0.664551H13.4639C13.5524 0.664551 13.641 0.681152 13.7295 0.714355C13.818 0.747559 13.8955 0.797363 13.9619 0.86377C14.0283 0.930176 14.0809 1.00765 14.1196 1.09619C14.1584 1.18473 14.1777 1.27881 14.1777 1.37842V12.7007C14.1777 12.8003 14.1584 12.8944 14.1196 12.9829C14.0809 13.0715 14.0283 13.1489 13.9619 13.2153C13.8955 13.2817 13.818 13.3315 13.7295 13.3647C13.641 13.3979 13.5524 13.4146 13.4639 13.4146H0.713867C0.625326 13.4146 0.536784 13.3979 0.448242 13.3647C0.359701 13.3315 0.282227 13.2817 0.21582 13.2153C0.149414 13.1489 0.0968424 13.0715 0.0581055 12.9829C0.0193685 12.8944 0 12.8003 0 12.7007V1.37842C0 1.27881 0.0193685 1.18473 0.0581055 1.09619C0.0968424 1.00765 0.149414 0.930176 0.21582 0.86377C0.282227 0.797363 0.359701 0.747559 0.448242 0.714355C0.536784 0.681152 0.625326 0.664551 0.713867 0.664551ZM12.75 3.66943L7.13867 8.69971L1.42773 3.65283V12.0034H12.75V3.66943ZM1.77637 2.07568L7.13867 6.80713L12.4014 2.07568H1.77637Z"
                    fill="#d33a3a"
                  />
                </svg>
                <span className="md:text-2xl text-xl font-medium tracking-tight">
                  admin@collegementor.com
                </span>
              </button>
            </div>

            <div className="flex md:gap-5 max-md:gap-4 md:flex-row max-md:flex-col   pb-4 md:pb-0 md:pr-9">
              <div className="flex gap-3 items-center">
                <p className="md:text-lg font-medium text-sm tracking-wide"></p>
              </div>
              <button className="flex items-center gap-2.5 rounded-lg border border-[#d33a3a] py-3 px-6 lg:min-w-[236px] justify-center">
                {/* <i className="icon-Phone text-[#d33a3a] text-2xl max-md:text-lg"></i> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13"
                  height="14"
                  viewBox="0 0 13 14"
                  fill="none"
                  className="text-2xl max-md:text-lg"
                >
                  <path
                    d="M12.75 10.1772V12.6675C12.75 12.7671 12.7334 12.8584 12.7002 12.9414C12.667 13.0244 12.6227 13.0991 12.5674 13.1655C12.501 13.2209 12.4263 13.2679 12.3433 13.3066C12.2603 13.3454 12.1745 13.3703 12.0859 13.3813C11.931 13.3924 11.7926 13.4007 11.6709 13.4062C11.5492 13.4118 11.4385 13.4146 11.3389 13.4146C9.76725 13.4146 8.29525 13.1157 6.92285 12.5181C5.55046 11.9315 4.34961 11.1235 3.32031 10.0942C2.29102 9.06494 1.48307 7.8641 0.896484 6.4917C0.298828 5.1193 0 3.6473 0 2.07568C0 1.98714 0.00276693 1.87923 0.00830078 1.75195C0.0138346 1.62467 0.0221354 1.48356 0.0332031 1.32861C0.0442708 1.24007 0.0691732 1.1543 0.10791 1.07129C0.146647 0.988281 0.193685 0.913574 0.249023 0.847168C0.31543 0.791829 0.390137 0.747559 0.473145 0.714355C0.556152 0.681152 0.647461 0.664551 0.74707 0.664551H3.2373C3.28158 0.664551 3.32585 0.672852 3.37012 0.689453C3.41439 0.706055 3.45312 0.730957 3.48633 0.76416C3.51953 0.786296 3.54443 0.816731 3.56104 0.855469C3.57764 0.894206 3.59147 0.93571 3.60254 0.97998C3.60254 1.06852 3.60807 1.14323 3.61914 1.2041C3.63021 1.26497 3.63574 1.32308 3.63574 1.37842C3.71322 1.8654 3.82389 2.34684 3.96777 2.82275C4.11165 3.29867 4.28874 3.75798 4.49902 4.20068C4.53223 4.27816 4.53776 4.35563 4.51562 4.43311C4.49349 4.51058 4.45475 4.57145 4.39941 4.61572L2.87207 5.69482C3.10449 6.24821 3.38672 6.76286 3.71875 7.23877C4.03971 7.72575 4.40771 8.17676 4.82275 8.5918C5.23779 9.00684 5.6888 9.38037 6.17578 9.7124C6.65169 10.0334 7.16634 10.3101 7.71973 10.5425L8.79883 9.03174C8.82096 8.99854 8.84863 8.97087 8.88184 8.94873C8.91504 8.9266 8.94824 8.90999 8.98145 8.89893C9.02572 8.88786 9.06722 8.88509 9.10596 8.89062C9.14469 8.89616 9.18066 8.90446 9.21387 8.91553C9.65658 9.12581 10.1159 9.3029 10.5918 9.44678C11.0677 9.59066 11.5492 9.70133 12.0361 9.77881C12.0915 9.77881 12.1523 9.78434 12.2188 9.79541C12.2852 9.80648 12.3571 9.81201 12.4346 9.81201C12.4788 9.82308 12.5203 9.83691 12.5591 9.85352C12.5978 9.87012 12.6338 9.89502 12.667 9.92822C12.6891 9.96143 12.7085 10.0002 12.7251 10.0444C12.7417 10.0887 12.75 10.133 12.75 10.1772Z"
                    fill="#d33a3a"
                  />
                </svg>
                <span className="md:text-2xl text-xl font-medium tracking-tight">
                  {config.mobileNumber}
                </span>
              </button>
            </div>
          </div>

          <div className="flex gap-1.5 font-medium">
            <p className="md:text-sm text-sm tracking-wide text-gray-700">
              Referral T&amp;C
            </p>
            <Link
              to={"/refer-earn-terms"}
              className="text-[#d33a3a] text-sm tracking-wide cursor-pointer"
            >
              Click Here
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReferralSupport;
